/* KHỐI "GIỚI THIỆU BẠN BÈ" TRÊN TRANG (section gioi-thieu-ban-be) — eGURU 18/09/2026, lệnh anh Thắng 13:03.
 *
 * VÌ SAO: sau demo, Derma thấy hộp BLOY khó dùng (nút nhỏ, phải bấm mới thấy). Landing/section trên trang là
 * mặt tiền chính; hộp BLOY chỉ còn là đường phụ. Phía B (hộp "Đăng ký nhận quà") KHÔNG đổi.
 *
 * LINK GIỚI THIỆU LẤY Ở ĐÂU: link của A KHÔNG có trong DOM/biến toàn cục lúc tải trang; BLOY chỉ sinh khi
 * router trong iframe widget vào màn /referral (POST generateRefferalLink có token riêng, gọi tay bị 403 —
 * website-theme-48 đo 12:20). Iframe widget là about:blank cùng nguồn và có sẵn cả khi hộp đang ĐÓNG, nên:
 *   1. đợi iframe có .BLOY-popup__referral-program-container (màn chính) → .click() (hộp vẫn đóng, khách không thấy)
 *   2. đợi input.BLOY-popup__referral_url_input có bloy_ref= → đọc; custom-bloy.js (ganMaGioiThieu) đã gắn &gt=<id A>,
 *      chưa kịp thì gắn ở đây — cùng định dạng
 *   3. bấm "Quay lại" để hộp về màn chính rồi mới trả link; cache localStorage gt_link_<id> 30 ngày
 * Không lấy được (BLOY đổi DOM, widget bị ẩn với tài khoản này, quá 15 s…) → FAIL-OPEN: hiện nút "Mở hộp Giới
 * thiệu bạn bè" = bấm nút nổi BLOY rồi vào màn giới thiệu (KHÔNG dùng deeplink #popup: nó mở hộp cả khi đang ẩn — anh Thắng 15:46).
 *
 * CHIA SẺ: Sao chép (Clipboard API, dự phòng execCommand) · Facebook: sharer.php. Nút Zalo đã bỏ 13:29 theo anh
 * Thắng (Zalo không có URL chia sẻ công khai, chỉ có SDK cần OA id) — khách sao chép rồi dán vào Zalo. Mọi CHỮ
 * (nhãn nút, báo "đã sao chép"…) lấy từ data-* do section đổ ra từ setting — không ghi cứng ở đây.
 *
 * KHÁCH LẠ: nút Đăng nhập ghi localStorage.gt_ve_lai = trang này; gioi-thieu-ban-be.js (chạy mọi trang) đưa khách
 * về lại sau khi đăng nhập (tài khoản mới Shopify bỏ return_url).
 */
(function () {
  'use strict';
  var DS = document.querySelectorAll('[data-gt-khoi]');
  if (!DS.length) return;

  function chu(k, khoi) { return (khoi || DS[0]).getAttribute('data-chu-' + k) || ''; }

  /* ---------- khách lạ: nhớ trang để quay lại sau đăng nhập ---------- */
  for (var i = 0; i < DS.length; i++) {
    (function (khoi) {
      var nut = khoi.querySelector('[data-gt-dang-nhap]');
      if (!nut) return;
      nut.addEventListener('click', function () {
        try { localStorage.setItem('gt_ve_lai', JSON.stringify({ duong: location.pathname + location.search + '#' + (khoi.id || 'khoi-gioi-thieu'), ts: Date.now() })); } catch (e) {}
      });
    })(DS[i]);
  }

  var id = DS[0].getAttribute('data-customer-id');
  if (!id) return;                                    // khách lạ / đại lý: không có phần link
  var KHOA = 'gt_link_' + id;
  var HAN = 30 * 86400000;

  function docCache() {
    try {
      var o = JSON.parse(localStorage.getItem(KHOA) || 'null');
      if (o && o.link && /bloy_ref=/.test(o.link) && Date.now() - (o.ts || 0) < HAN) return o.link;
    } catch (e) {}
    return '';
  }
  function ghiCache(link) { try { localStorage.setItem(KHOA, JSON.stringify({ link: link, ts: Date.now() })); } catch (e) {} }

  function themGt(l) {
    if (/[?&]gt=/.test(l)) return l;
    return l.replace(/(bloy_ref=[A-Za-z0-9_-]+)/, '$1&gt=' + id);
  }
  function chuanLink(l) {
    l = String(l || '').trim();
    if (!l) return '';
    if (!/^https?:\/\//i.test(l)) l = 'https://' + l;
    return themGt(l);
  }

  /* ---------- lấy link từ iframe BLOY (hộp đang đóng) ---------- */
  function docBloy() {
    var f = document.querySelector('.BLOY-popup iframe');
    var d = null;
    try { d = f && f.contentDocument; } catch (e) { return null; }
    return d && d.body ? d : null;
  }
  function layTuBloy(xong, hong) {
    var bd = Date.now(), daBam = false, HET = 15000;
    var vong = setInterval(function () {
      var d = docBloy();
      if (d) {
        var o = d.querySelector('input.BLOY-popup__referral_url_input');
        if (o && /bloy_ref=/.test(o.value || '')) {
          clearInterval(vong);
          var link = chuanLink(o.value);
          var lui = d.querySelector('.BLOY-popup__action--back');
          if (lui && daBam) { try { lui.click(); } catch (e) {} }
          xong(link);
          return;
        }
        if (!daBam) {
          var the = d.querySelector('.BLOY-popup__referral-program-container, .BLOY-popup__referral-program');
          if (the) { daBam = true; try { the.click(); } catch (e) {} }
        }
      }
      if (Date.now() - bd > HET) { clearInterval(vong); hong(); }
    }, 300);
  }

  /* ---------- điền vào khối ---------- */
  function baoNho(khoi, msg) {
    var b = khoi.querySelector('[data-gt-bao]');
    if (!b) return;
    b.textContent = msg;
    b.classList.add('gt-khoi__bao--hien');
    clearTimeout(b._hen);
    b._hen = setTimeout(function () { b.classList.remove('gt-khoi__bao--hien'); }, 3500);
  }
  function saoChep(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text);
    return new Promise(function (res, rej) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      var ok = false; try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      ok ? res() : rej();
    });
  }
  function dien(khoi, link) {
    khoi.setAttribute('data-gt-trang-thai', 'co-link');
    var o = khoi.querySelector('[data-gt-o-link]');
    if (o) { o.value = link; o.addEventListener('focus', function () { o.select(); }); }
    var nutChep = khoi.querySelector('[data-gt-sao-chep]');
    if (nutChep) {
      nutChep.removeAttribute('disabled');
      nutChep.addEventListener('click', function () {
        saoChep(link).then(function () { baoNho(khoi, chu('da-chep', khoi)); }, function () { if (o) { o.focus(); o.select(); } });
      });
    }
    // 13:49 — 4 nút chia sẻ như hộp BLOY, link chuẩn của từng mạng; Messenger chỉ có deep link app → chỉ hiện trên điện thoại
    var loi = chu('loi-moi', khoi); var chuVaLink = (loi ? loi + ' ' : '') + link;
    var laDienThoai = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    var DIA_CHI = {
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(link),
      messenger: 'fb-messenger://share?link=' + encodeURIComponent(link),
      x: 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(loi || '') + '&url=' + encodeURIComponent(link),
      whatsapp: 'https://wa.me/?text=' + encodeURIComponent(chuVaLink)
    };
    var nutChia = khoi.querySelectorAll('[data-gt-chia]');
    for (var c = 0; c < nutChia.length; c++) {
      var mang = nutChia[c].getAttribute('data-gt-chia');
      if (!DIA_CHI[mang]) continue;
      if (mang === 'messenger') { if (!laDienThoai) continue; nutChia[c].removeAttribute('hidden'); nutChia[c].removeAttribute('target'); }
      nutChia[c].href = DIA_CHI[mang];
      nutChia[c].removeAttribute('aria-disabled');
    }
  }
  function duPhong(khoi) {
    khoi.setAttribute('data-gt-trang-thai', 'du-phong');
    var nut = khoi.querySelector('[data-gt-mo-hop]');
    if (!nut) return;
    // 15:46: chế độ ẩn hộp BLOY (body.eguru-an-nut) → hộp mở cũng không thấy → chỉ hiện chữ, giấu nút; không gắn #popup nữa
    if (document.body.classList.contains('eguru-an-nut')) { nut.hidden = true; return; }
    nut.addEventListener('click', function () {
      var launcher = document.querySelector('.BLOY-widget');
      if (!launcher) return;
      launcher.click();
      var lan = 0, v = setInterval(function () {
        var d = docBloy();
        var the = d && d.querySelector('.BLOY-popup__referral-program-container');
        if (the) { clearInterval(v); the.click(); }
        else if (++lan > 20) clearInterval(v);
      }, 250);
    });
  }

  var cache = docCache();
  if (cache) {
    for (var k = 0; k < DS.length; k++) dien(DS[k], cache);
    return;
  }
  layTuBloy(function (link) {
    ghiCache(link);
    for (var k2 = 0; k2 < DS.length; k2++) dien(DS[k2], link);
  }, function () {
    for (var k3 = 0; k3 < DS.length; k3++) duPhong(DS[k3]);
  });
})();
